import * as React from "react";
import { Note } from "components/form";
import { VariableLookupText } from "components/form/Text/Text";
import styles = require("./style.less");

interface MaxParallelismProps {
    projectId: string;
    value: string;
    onChange(newValue: string): void;
}

const MaxParallelism: React.StatelessComponent<MaxParallelismProps> = props =>
    <div>
        <VariableLookupText
            localNames={[]}
            projectId={props.projectId}
            value={props.value}
            onChange={props.onChange}
            label="Window size" />
        <Note>
            <p>When deploying to multiple deployment targets, you
                            can configure the rolling window size to use. For example:</p>
            <ul className={styles.noteList}>
                <li>A window size of 1 will deploy to a single deployment target at
                                a time. Octopus will wait for the step to finish running on
                                deployment target A before starting on deployment target B.
                            </li>
                <li>A window size of 3 will deploy to three deployment targets at a
                                time. Octopus will wait for the step to finish running on
                                deployment targets A, B or C before starting on deployment
                                target D.
                            </li>
            </ul>
            <p>Omitting the window size will run the step against
                            all deployment targets at once.</p>
        </Note>
    </div>;

export default MaxParallelism;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/DeploymentProcess/MaxParallelism.tsx